// vocabulary/middle.ts
import { VocabPair } from './types';

export const middle: VocabPair[] = [
  { word: "Ambiguous", definition: "Unclear or having multiple meanings" },
  { word: "Collaborate", definition: "Work together" },
  { word: "Persevere", definition: "Keep trying despite difficulties" },
  { word: "Elaborate", definition: "Detailed and complicated" },
  { word: "Resilient", definition: "Able to recover quickly" },
  { word: "Skeptical", definition: "Doubting or questioning" },
  { word: "Vibrant", definition: "Full of energy and life" },
  { word: "Integrity", definition: "Being honest and having strong moral principles" },
  { word: "Contemplate", definition: "Think deeply about something" },
  { word: "Emphasize", definition: "Give special importance to something" },
  { word: "Innovative", definition: "Introducing new ideas or methods" },
  { word: "Proficient", definition: "Skilled and competent" },
  { word: "Comprehensive", definition: "Complete and thorough" },
  { word: "Demonstrate", definition: "Show or prove something" },
  { word: "Analyze", definition: "Examine in detail" },
  { word: "Synthesize", definition: "Combine different elements" },
];